import { createStyles, makeStyles, Theme } from '@material-ui/core';

const useStyles = makeStyles(({ palette, breakpoints }: Theme) => createStyles({
  buttonAddScene: {
    minWidth: 'unset',
    marginLeft: 10,
    padding: 5,
    color: palette.primary.main,
    border: 'solid 1px #FFF',
    '&:hover': {
      border: `solid 1px ${palette.buttonAction.background}`,
    },
  },
  labelAddScene: {
    fontFamily: 'Montserrat, sans-serif',
    fontSize: '16px',
    fontWeight: 800,
    textTransform: 'none',
  },
  spinnerWrapper: {
    display: 'flex',
    position: 'absolute',
    top: 0,
    bottom: 0,
    left: 0,
    right: 0,
    justifyContent: 'center',
    alignItems: 'center',
    zIndex: 2147483100,
  },
  actionContainer: {
    marginBottom: '40px',
  },
  iconButton: {
    width: '16px',
    height: '16px',
    marginRight: '8px',
  },
  icon: {
    color: palette.icons.default,
  },
  gripIcon: {
    color: palette.expansionPanelSummary.borderColor,
  },
  title: {
    color: palette.expansionPanelSummary.color,
    fontFamily: 'Montserrat',
    fontSize: '18px',
    fontWeight: 500,
  },
  inputUnderline: {
    borderBottom: `1px solid ${palette.input.borderBottomColor}`,
    '&:before': {
      borderBottom: `1px solid ${palette.input.borderBottomColor}`,
      [breakpoints.up('sm')]: {
        borderBottomColor: 'transparent',
      },
    },
    '&&:hover:before': {
      borderWidth: 1,
      borderBottomColor: palette.input.borderBottomColor,
    },
    '&:after': {
      borderBottomColor: palette.menuAction.selected,
    },
  },
  scriptListActionContainer: {
    width: '100%',
    maxWidth: 400,
    minWidth: 248,
  },
  wordCount: {
    paddingLeft: 10,
    whiteSpace: 'nowrap',
  },
  additionalPanel: {
    display: 'flex',
    alignItems: 'center',
  },
}), { name: 'ScriptsPage' });

export default useStyles;
